import React from "react";
import { Grid, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Collapse from "@material-ui/core/Collapse";
import CustomTextField from "../common/CustomTextField";
import SwitchWithLabel from "../common/CustomSwitch";
import {
  formatAddress,
  getStopServiceWindowByStopType,
} from "../../../utils/utils";
import { MAX_LENGTH_CONSTRAINTS } from "../common/constants";
import StopWindowDetails from "../common/StopWindowDetails";

const styles = (theme) => ({
  rowStyle: {
    marginBottom: 8,
  },
  containerStyle: {
    marginTop: 24,
  },
  stopName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  stopAddress: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
  pickupWindow: {
    fontWeight: 400,
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    maxHeight: "32px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    "-webkit-line-clamp": "2",
    "-webkit-box-orient": "vertical",
  },
  pickupWindowDetails: {
    fontWeight: 400,
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    textAlign: "justify",
  },
  pickupWindowLabel: {
    fontWeight: 600,
    fontSize: 12,
    color: theme.dispatchPanelLabelValueColor,
    textTransform: "uppercase",
    marginBottom: 8,
    marginTop: 24,
  },
  viewMore: {
    fontWeight: 400,
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    textDecorationLine: "underline",
    color: theme.proNumberColor,
    cursor: "pointer",
    marginTop: "8px",
    marginBottom: "16px",
  },
  fullWidth: { width: "100%" },
  pickupDetailsStyle: {
    width: "100%",
    fontSize: "14px",
  },
  pickupNumber: {
    fontWeight: 500,
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    textAlign: "right",
    color: theme.ToggleIconColor,
  },
  deliveryTimeInfo: {
    marginBottom: 16,
  },
});
class PickupDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false,
    };
  }
  changeValue = () => {
    this.setState((state) => ({ showMore: !state.showMore }));
  };
  handleChange = (name) => (value) => {
    const { handleChange } = this.props;
    handleChange(name)(value);
  };
  render() {
    const {
      classes,
      stopData,
      isArrivalTimeDisabled,
      isShipperLoadAndCount,
      isNoFreight,
      pickupInfo,
      pickupErrorInfo,
      forwardRef,
      stopTimeInfo,
      handleStopTimeChange,
      isSLCDisabled,
      isReadOnly
    } = this.props;
    const specialInstructionLabel = this.state.showMore
      ? "View less"
      : "View more";
    const specialInstructionClass = this.state.showMore
      ? classes.pickupWindowDetails
      : classes.pickupWindow;
    return (
      <React.Fragment>
        <Grid container className={classes.containerStyle}>
          <Grid item xs={12} className={classes.rowStyle}>
            <Grid container>
              <Grid item xs={8}>
                <div className={classes.stopName}>{stopData.name}</div>
                <div className={classes.stopAddress}>
                  {formatAddress({
                    address: stopData?.address,
                    address2: stopData?.address2,
                    city: stopData?.city,
                    state: stopData?.state,
                    zip: stopData?.zip,
                  })}
                </div>
              </Grid>
              <Grid item xs={4} className={classes.pickupNumber}>
                {`#${stopData.accountNumber}`}
              </Grid>
            </Grid>
          </Grid>
          {!isNoFreight && (
            <div className={classes.pickupDetailsStyle}>
              <SwitchWithLabel
                rowLabel="Shipper Load and Count"
                onChange={this.handleChange("isShipperLoadAndCount")}
                value={isShipperLoadAndCount}
                disabled={isSLCDisabled || isReadOnly}
              />
            </div>
          )}
          <div className={classes.pickupDetailsStyle}>
            <SwitchWithLabel
              rowLabel="Is driver allowed inside to complete pickup?"
              onChange={this.handleChange("isDriverAllowedInside")}
              value={pickupInfo.isDriverAllowedInside}
              disabled={isReadOnly}
            />
          </div>

          <div
            id="pickupDetails"
            ref={forwardRef}
            className={classes.pickupDetailsStyle}
          >
            <SwitchWithLabel
              rowLabel="No Freight"
              onChange={this.handleChange("isNoFreight")}
              value={isNoFreight}
              disabled={isReadOnly}
            />
            <Collapse in={isNoFreight} className={classes.fullWidth}>
              <CustomTextField
                className={classes.fullWidth}
                id="customerName"
                handleChange={this.handleChange("customerName")}
                value={pickupInfo.customerName}
                error={pickupErrorInfo.customerName}
                inputProps={{
                  maxLength:
                    MAX_LENGTH_CONSTRAINTS.NO_FREIGHT_FORM.CUSTOMER_NAME,
                  focused: true,
                }}
                label="Customer (First and Last) Name"
              />
            </Collapse>
          </div>

          {stopData.specialInstructions ? (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12} className={classes.pickupWindowLabel}>
                  special instructions
                </Grid>
                <Grid item xs={12} className={specialInstructionClass}>
                  {stopData.specialInstructions}
                </Grid>
                <div className={classes.viewMore} onClick={this.changeValue}>
                  {specialInstructionLabel}
                </div>
              </Grid>
            </Grid>
          ) : null}
        </Grid>

        <Divider />
        <div className={classes.deliveryTimeInfo}>
          <StopWindowDetails
            arrivalTime={stopTimeInfo.stopTime.arrivalTime}
            departureTime={stopTimeInfo.stopTime.departureTime}
            arrivalTimeError={stopTimeInfo.stopTimeError.arrivalTime}
            departureTimeError={stopTimeInfo.stopTimeError.departureTime}
            handleChange={handleStopTimeChange}
            stopData={stopData}
            timeWindow={getStopServiceWindowByStopType(stopData)}
            timeWindowLabel="Pickup Window"
            isArrivalTimeDisabled={isArrivalTimeDisabled}
            isReadOnly={isReadOnly}
          />
        </div>
        <Divider />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PickupDetails);
